module.exports = __webpack_public_path__ + "static/media/log-in.5ae2542c.svg";